import { globalUtilInit, loadLazyImages, realResizeEvent, xssEscaper } from "../utilities/globalUtilities";
import { initTooltip } from "../components/toolTip";

var debounce = require("lodash/debounce");
var urlUtils = require("../search/urlUtils");
const scrollLock = require("../utilities/scrollLock");
const { refreshStickyWrapperHeight } = require("../utilities/stickyHelpers");
var endpoint = $(".suggestions-wrapper").data("url");
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;
var $modalBackground = $(".js-modal-bg");
var $resetButton = $(".reset-button");
var $searchField = $(".search-field");
const minChars = document.querySelector(".global-search-form")?.dataset?.minChars || 1;

const $cache = {
    body: $("body"),
    window: $(window)
};

let windowWidth = $cache.window.width();

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).siblings(".suggestions-wrapper");
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest(".search-mobile").length;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    if ($cache.body.hasClass("modal-open")) {
        scrollLock.disable();
    }

    $("body").removeClass("modal-open");
    $("header").siblings().attr("aria-hidden", "false");
    $(".suggestions").removeClass("modal");
    $modalBackground.removeClass("header-visible").hide();
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $("header").siblings().attr("aria-hidden", "true");
        getSuggestionsWrapper(scope).find(".suggestions").addClass("modal");
        $(".search-mobile").addClass("search-shadow");

        if (!window.mqRespond.status.tablet) {
            $("body").addClass("modal-open");
            scrollLock.enable();
        }
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $("input.search-field").val("");
    if (!$(".navigation-open").length) {
        clearModals();
    }
    $(".search-mobile .suggestions").unbind("scroll");
    $(".suggestions-wrapper").empty();
    $cache.body.removeClass("modal-open");
    scrollLock.disable();
    refreshStickyWrapperHeight();
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    if (($(scope).scrollTop() + $(scope).innerHeight()) >= $(scope)[0].scrollHeight) {
        $(".more-below").fadeOut();
    } else {
        $(".more-below").fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    var outerHeight;
    var $scope;
    var $suggestions;
    var top;

    if (isMobileSearch(scope)) {
        $scope = $(scope);
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find(".suggestions");
        $suggestions.css("top", top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();
    $modalBackground.addClass("header-visible").show();
    $.spinner().stop();

    if (!(typeof (response) === "object")) { //NOSONAR
        $suggestionsWrapper.append(response).show();
        //highlights characters typed in search bar
        var term = $(this).val().trim();
        $suggestionsWrapper.find(".non-product").find(".suggested-item").each(function () {
            var text = $(this).text();
            $(this).html(text.replace(new RegExp(term, "gi"), "<span class='highlight'>" + term + "</span>"));
        });
        positionSuggestions(this);

        if (isMobileSearch(this)) {
            applyModals(this);
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $(".suggestions .suggestions-item");
        if ($(suggestionsList).length) {
            $("input.search-field").attr("aria-describedby", "search-result-count");
        } else {
            $("input.search-field").removeAttr("aria-describedby");
        }

        $(".suggestion-product-item").each((index, item) => {
            const productID = item.dataset.pid;

            initTooltip(`.suggestion-product-item[data-pid=${productID}]`);
        });

        // If the `suggestions all btn` is clicked then submit the search query
        const suggestionsAllLink = document.querySelector(".js-suggestions-all-btn");
        if (suggestionsAllLink != null) {
            suggestionsAllLink.addEventListener("click", () => {
                document.querySelector(".global-search-form").submit();
            });
        }
    } else {
        $suggestionsWrapper.hide();
        if (response.hide) {
            $modalBackground.hide();
        }
    }

    $cache.body.toggleClass("modal-open", $suggestionsWrapper.find(".suggestions").length != 0);
    var $suggestions = $suggestionsWrapper.find(".suggestions");

    if ($suggestions.length != 0) {
        const MIN_DESKTOP_HEIGHT_NO_SCROLL = 850;
        
        if ($(window).innerHeight() < MIN_DESKTOP_HEIGHT_NO_SCROLL && !$suggestions.hasClass("modal")) {
            const SEARCH_WRAPPER_TOP_PADDING = 100;
            var stickyElementsHeight = $(".header-wrapper").height() + $(".js-header-banner").height() + $(".search-field").height() + SEARCH_WRAPPER_TOP_PADDING;
            $suggestions.css("overflow-y", "scroll");
            $suggestions.css("max-height", $(window).innerHeight()).css("max-height", `-=${stickyElementsHeight}px`);
        }
        
        scrollLock.enable();
    } else {
        scrollLock.disable();
    }

    if (window.scrollY != 0) { window.scrollTo(0, 0); }

    globalUtilInit();
    loadLazyImages();
    document.dispatchEvent(new Event("dataLayer.showSuggestions"));
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    if ($(scope).val().length >= minChars) {
        $.spinner().start();
        $(scope).val(xssEscaper($(scope).val()));

        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($(scope).val()),
            method: "GET",
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
    } else {
        clearModals();
        getSuggestionsWrapper(scope).empty();
        if ($cache.body.hasClass("modal-open")) {
            scrollLock.disable();
        }
        $cache.body.removeClass("modal-open");
    }
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $(".suggestions .suggestions-item");
    if (suggestionsList.filter(".selected").length === 0) {
        suggestionsList.first().addClass("selected");
        $("input.search-field").each(function () {
            $(this).attr("aria-activedescendant", suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
                $(this).removeAttr("aria-selected");
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass("selected");
                    suggestionsList.eq(idx).attr("aria-selected", true);
                    $(this).removeProp("aria-selected");
                    $("input.search-field").each(function () {
                        $(this).attr("aria-activedescendant", suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass("selected");
                    suggestionsList.first().attr("aria-selected", true);
                    $("input.search-field").each(function () {
                        $(this).attr("aria-activedescendant", suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

/**
 * Attach/detach global search form to different elements, depending on the breakpoint
 */
const moveGlobalSearchForm = () => {
    const $globalSearchForm = $(".global-search-form");
    const $desktopSearchWrapper = $(".search");
    const $mobileSearchWrapper = $(".search-mobile");

    if (window.mqRespond.status.mobile || window.mqRespond.status.tablet) {
        $globalSearchForm.detach().appendTo($mobileSearchWrapper);
    } else {
        $globalSearchForm.detach().appendTo($desktopSearchWrapper);
    }
};

module.exports = function () {
    moveGlobalSearchForm();

    $cache.window.on("resize", debounce(() => {
        if (!realResizeEvent(windowWidth)) { return; }

        windowWidth = $cache.window.width();

        moveGlobalSearchForm();
    }, 200));

    $("form[name=\"simpleSearch\"]").submit(function (e) {
        var suggestionsList = $(".suggestions .suggestions-item");
        if (suggestionsList.filter(".selected").length !== 0) {
            e.preventDefault();
            suggestionsList.filter(".selected").find("a")[0].click();
        }
    });

    $("input.search-field").each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 750);
        $(this).on("keyup focus", function (e) {
            var $this = $(this);

            $this.siblings(".search-suggestions-actions").find(".reset-button").toggleClass("d-block", $this.val() != "");
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                default:
                    debounceSuggestions(this, e);
            }
        });
    });

    const currentURL = window.location.href;
    if (currentURL.includes("q=")) {
        const searchText = urlUtils.getURLParameter(currentURL, "q");
        if (searchText.length > 0) {
            $("#input-custom-label-search").val(searchText);
            $resetButton.removeClass("d-block");
            $searchField.addClass("filled");
            $(".search-mobile").removeClass("search-shadow");
        }
    }

    $("body").on("click", function (e) {
        if (!$(".suggestions").has(e.target).length && !$(e.target).hasClass("search-field") && !$(e.target).is(".search-button") && !$(e.target).is(".svg-wrapper") && $(".modal.show").length == 0 && ($(".suggestions .suggestions-item").length || $(".suggestions-header").length)) {
            tearDownSuggestions();
            $resetButton.removeClass("d-block");
            $searchField.removeClass("filled");
            $(".search-mobile").removeClass("search-shadow");
        }
    });

    $resetButton.on("click touchend", function () {
        var $this = $(this);

        if ($this.closest(".field-input-label").find(".search-field").hasClass("filled")) {
            $this.closest(".field-input-label").find(".search-field").removeClass("filled");
        }

        tearDownSuggestions();
        $(".search-mobile").removeClass("search-shadow");
        $(this).removeClass("d-block");
    });
};
